import { MediaType } from '../DolEditor/elements/media-constant';
import { DoTestImageWithBlankPluginAdminItem } from './DoTestImageWithBlankPluginAdminItem';
import { BlankChange } from '../BlankEditor/DoTest/Blank';

export interface DoTestImageWithBlankPluginOptions {
  blanks?: any;
  editorValue?: any;
  blankValues?: BlankChange[];
  no?: number;
  onBlankChange?: (input: BlankChange) => void;
}

export const DoTestImageWithBlankPlugin = (props) => {
  return {
    renderElement: DoTestImageWithBlankPluginAdminItem(props),
    voidTypes: [MediaType.IMAGE],
    renderElementDeps: [
      props?.blanks,
      props?.editorValue,
      props?.onBlankChange,
      props?.blankValues,
    ],
  };
};
